import { useState, useEffect } from "react";
import {Carousel} from "./Components/Carousel"
import Sidebar from "./Components/Sidebar/Sidebar";
import { CustomThemeContext } from "./ThemeContext";
import "./styles.css"

const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

function App() {
   const [mode,changeMode] = useState(useDarkMode?"Dark":"Light");
   const [selected,select] = useState(0);
   const [uname,changeUname] = useState("");
   const [photo,changePhoto] = useState("");

   useEffect(()=>{
      changeUname(window.UNAME);
      changePhoto(window.profile_img);
   },[]);

   var user = {
      logged : (uname !== ""),
      name : uname,
      image : photo
   }
   
   return (
      <>
            <CustomThemeContext.Provider value = {{
                  Mode : mode , 
                  User : user,
                  ChangeSelect : select,
                  ChangeMode : ()=>{changeMode(mode === "Dark"?"Light":"Dark")}
               }}>
               <Sidebar Select={selected}/>
               <Carousel/>
            </CustomThemeContext.Provider>
      </>
   );
}

export default App;
